import React  from 'react';
export const elementsProps = { 
    // "view":["isFluid", "fontFamily", "textSizeWeb", "overlayColor", "background", "backgroundWeb", "defaultHeaderBgColor", "textColor", "textAlignment",  "enableDivider", "paddingWeb", "isMap", "isFlipped","marginWeb"],
    // "text":["fontFamily", "textSizeWeb", "textColor", "background", "overlayColor",  "textAlignment", "paddingWeb", "media"],
    // "textHtml":["fontFamily",  "textSizeWeb", "textColor", "background", "overlayColor", "textAlignment", "paddingWeb", "isMap"],
    // "image":["src", "background", "cornerType", "paddingWeb"],
    // "grid":["fontFamily", "paddingWeb", "textColor", "background", "overlayColor", "textAlignment", "spanWeb"],
    // "gridItem":[ "fontFamily", "textSizeWeb", "textColor", "background", "overlayColor", "itemAlignment", "textAlignment", "paddingWeb", "isFlipped", "borderSize","marginWeb"],
    // "socialLinks":["iconColor", "iconAlignment", "iconBackground", "marginWeb"],
    // "hours":["fontFamily", "textSizeWeb", "textColor", "textAlignment", "overlayColor", "background", "paddingWeb"],
    // "button":["fontFamily", "textSizeWeb", "textColor", "background", "overlayColor","borderColor", "paddingWeb"],
    // "icon":[ "iconColor","iconSizeWeb","iconBackground", "iconAlignment", "paddingWeb"],
    // "contactLinks":["fontFamily", "textSizeWeb", "textColor", "textAlignment", "overlayColor", "background", "paddingWeb"],
     // "logo":["fontFamily", "textSizeWeb", "textColor", "paddingWeb"],
        // "fontFamily", "textSizeWeb", "textColor", "background", "textColorActive", "backgroundActive", "borderWidget", "paddingWeb", "borderRadius"],
    // "headerSocialLinks":["iconColor", "iconBackground"],
    // "headerIcons":["iconColor","iconSizeWeb","activeColor","iconBackground", "cornerType","paddingWeb", "iconTextColor","iconTextBgColor"],
    // "video":["videoSrc", "ratio" ,"autoPlay", "loop", "background","overlayColor", "paddingWeb"],
   
   
    //view Done
    "view":[
        {
            tabType:"regular",
            list:[  
                {   
                    type:"colorType", 
                    item:["textColor","background","backgroundWeb","defaultHeaderBgColor","overlayColor"]
                },
                {   
                    type:"fontType", 
                    item:["fontFamily","textSizeWeb","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb","marginWeb","isFluid","linkSpacing","elementSpacing","headerHeight"]
                },
                {   
                    type:"shadowType",
                    item:["dropShadow"]
                },
                {   
                    type:"settingsType",
                    item:["enableDivider","isMap","FlipSwiperGrid","headerSetting", "footerSetting"]
                }
            ]
        } 
    ],
    "grid":[
        {
            tabType:"regular",
            list:[  
                {   
                    type:"colorType", 
                    item:["textColor","background","overlayColor"]
                },
                {   
                    type:"fontType", 
                    item:["fontFamily","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                },
                {   
                    type:"settingsType",
                    item:["spanWeb"]
                }
            ]
        } 
    ],  
    //gridItem Done
    "gridItem":[
        {
            tabType:"regular",
            list:[  
                {   
                    type:"colorType", 
                    item:["textColor","background","overlayColor"]
                }, 
                {   
                    type:"borderType",
                    item:["borderColor","borderType","borderSize","borderWidget"]
                }, 
                {   
                    type:"fontType", 
                    item:["fontFamily","textSizeWeb","itemAlignment","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb","marginWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["borderCorners"]
                },
                {   
                    type:"settingsType",
                    item:["collapse","mandatory","placeholder","inputType"]
                },
            ]
        } 
    ], 
    //text Done
    "textHtml":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["textColor","background","overlayColor"]
                },
                {   
                    type:"fontType",
                    item:["tagType", "fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    "list":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["iconColor","iconBackground", "textColor","background","overlayColor"]
                },
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    "skills":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["textColor","background", "trackColor", "fillColor"]
                },
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    "tags":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["tagColor", "tagBackground","background"]
                },
                {   
                    type:"borderType",
                    item:["borderColor","borderType","borderSize"]
                }, 
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    "pricingPlanPrice":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["textColor","background"]
                },
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    "menu":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["iconColor","iconBackground", "textColor","background","overlayColor"]
                },
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    "input":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["textColor","background"]
                },
                {   
                    type:"borderType",
                    item:["borderColor","borderType","borderSize","borderWidget"]
                }, 
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb","marginWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["borderCorners"]
                },
            ]
        } 
    ],
    
    //text Done
    "text":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["textColor","background","overlayColor"]
                },
                {   
                    type:"fontType",
                    item:["tagType", "fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    "copyRight":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["textColor","background","overlayColor"]
                },
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle"]
                }, 
                {   
                    type:"borderType",
                    item:["borderColor","borderType","borderSize"] 
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb", "marginWeb"]
                }
            ]
        } 
    ],
    //image Done
    "image":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"linkType"
                },
                {   
                    type:"mediaType",
                    item:["src"]
                },
                {   
                    type:"colorType",
                    item:["background"]
                }, 
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["cornersWeb"]
                }
            ]
        } 
    ],
    //button Done check again border
    "button":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"linkType"
                },
                {   
                    type:"colorType",
                    item:["textColor","background","overlayColor"]
                },
                {   
                    type:"borderType",
                    item:["borderColor"]
                }, 
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["cornersWeb"]
                }
            ]
        } 
    ], 
    //hours Done
    "hours":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["textColor","background","overlayColor"]
                },
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    //contactLinks Done
    "contactLinks":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["textColor","background","overlayColor"]
                },
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb","textStyle","textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                }
            ]
        } 
    ],
    //icon Done
    "icon":[
        {
            tabType:"regular",
            
            list:[ 
                {   
                    type:"linkType"
                },
                {   
                    type:"mediaType",
                    item:["iconCode"]
                },
                {   
                    type:"colorType",
                    item:["iconColor","iconBackground"]
                },
                {   
                    type:"fontType",
                    item:["iconSizeWeb","iconAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["cornersWeb"]
                }
            ]
        } 
    ],
    //socialLinks Done
    "socialLinks":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["iconColor","iconBackground"]
                },
                {   
                    type:"fontType",
                    item:["iconAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["marginWeb"]
                }
            ]
        } 
    ], 
    //video Done
    "video":[
        {
            tabType:"regular",
            list:[  
                {   
                    type:"mediaType",
                    item:["videoSrc"]
                },
                {   
                    type:"colorType", 
                    item:["background","overlayColor"]
                }, 
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                },
                {    
                    type:"settingsType",
                    item:["autoPlay","loop"]
                }
            ]
        } 
    ],

    "logo":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"logoType",
                    item:["logo","logoTitle"]
                },
                {   
                    type:"colorType",
                    item:["textColor"]
                },
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb", "textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb","logoDimension"]
                }
            ]
        } 
    ],

    "navigation":[
        {
            tabType:"regular",
            list:[
                
                {   
                    type:"colorType",
                    item:["textColor","background", "navBackground", "submenuTextColor", "submenuBackground"]
                },
                {   
                    type:"borderType",
                    item:["borderWidget","borderColor","borderType", "menuBorderWidget","menuBorderColor","menuBorderType", "borderRadius"]
                }, 
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb"]
                },  
                {   
                    type:"spacingType",
                    item:["navPaddingWeb","paddingWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["borderCorners"]
                }
            ]
        },
        {
            tabType:"hover",
            list:[
                {   
                    type:"colorType",
                    item:["textColorHover", "backgroundHover", "submenuTextColorHover", "submenuBackgroundHover"]
                },
                {   
                    type:"borderType",
                    item:["borderColorHover"]
                },
            ]
        },
        {
            tabType:"clicked",
            list:[
                {   
                    type:"colorType",
                    item:["textColorClick", "backgroundClick", "submenuTextColorClick", "submenuBackgroundClick"]
                },
                {   
                    type:"borderType",
                    item:["borderColorClick"]
                },
            ]
        }
        
    ], 
    "footerNavigation":[
        {
            tabType:"regular",
            list:[
                
                {   
                    type:"colorType",
                    item:["textColor","background"]
                },
                {   
                    type:"borderType",
                    item:["borderColor","borderType","borderWidget", "borderRadius"]
                }, 
                {   
                    type:"fontType",
                    item:["fontFamily","textSizeWeb", "textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["navPaddingWeb","paddingWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["borderCorners"]
                }
            ]
        },
        {
            tabType:"hover",
            list:[
                {   
                    type:"colorType",
                    item:["textColorHover", "backgroundHover"]
                },
                {   
                    type:"borderType",
                    item:["borderColorHover"]
                },
            ]
        },
        {
            tabType:"clicked",
            list:[
                {   
                    type:"colorType",
                    item:["textColorClick", "backgroundClick"]
                },
                {   
                    type:"borderType",
                    item:["borderColorClick"]
                },
            ]
        }
        
    ], 
    "advanceSocialLinks":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["iconColor","iconBackground"]
                },
                {   
                    type:"fontType",
                    item:["iconSizeWeb", "textAlignment"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["cornersWeb"]
                }
            ]
        } 
    ],
    "headerIcons":[
        {
            tabType:"regular",
            list:[ 
                {   
                    type:"colorType",
                    item:["iconColor","iconBackground","iconTextColor","iconTextBgColor"]
                },
                {   
                    type:"fontType",
                    item:["iconSizeWeb"]
                },  
                {   
                    type:"spacingType",
                    item:["paddingWeb"]
                },
                {   
                    type:"borderCornersType",
                    item:["cornersWeb"]
                }
            ]
        }
    ]  
} 

 
export const elementsStyle = {
    "text":[
        {key:"fontSize", value:"textSizeWeb"},
        {key:"color", value:"textColor"}, 
        {key:"background", value:"background"},
        {key:"padding", value:"paddingWeb"},
        {key:"fontFamily", value:"fontFamily"},
    ],
    "textHtml":[
        {key:"fontSize", value:"textSizeWeb"},
        {key:"color", value:"textColor"}, 
        {key:"background", value:"background"},
        {key:"padding", value:"paddingWeb"} , 
        {key:"fontFamily", value:"fontFamily"},
    ],
    "copyRight":[
        {key:"fontSize", value:"textSizeWeb"},
        {key:"color", value:"textColor"}, 
        {key:"background", value:"background"},
        {key:"padding", value:"paddingWeb"} , 
        {key:"fontFamily", value:"fontFamily"},
        {key:"border", value:"borderSize"},
        {key:"margin", value:"marginWeb"}
    ],
    "image":[],
    "view":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"},
        {key:"color", value:"textColor"},
        {key:"borderBottom", value:"dividerSize"},
        {key:"boxShadow", value:"dropShadow"}
    ],
    "grid":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"} 
    ],
    "gridItem":[ 
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"},
        {key:"fontSize", value:"textSizeWeb"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"},
        {key:"border", value:"borderSize"},
        {key:"borderWidget", value:"borderWidget"},
        {key:"borderRadius", value:"borderCorners"},
        {key:"margin", value:"marginWeb"},
    ],
    "socialLinks":[
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"},
        {key:"margin", value:"marginWeb"},
    ], 
    "hours":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},
        {key:"background", value:"background"},
        {key:"padding", value:"paddingWeb"},
    ],
    "button":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},
        {key:"background", value:"background"}, 
        {key:"padding", value:"paddingWeb"},
        {key:"buttonBorder", value:"borderColor"},
    ],
    "icon":[
        {key:"color", value:"iconColor"}, 
        {key:"background", value:"iconBackground"},
        {key:"fontSize", value:"iconSizeWeb"},
        {key:"padding", value:"paddingWeb"},
    ],
    "contactLinks":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"}
    ],
    "navigation":[ 
        {key:"fontFamily", value:"fontFamily", type:"fontType"}, 
        {key:"fontSize", value:"textSizeWeb", type:"fontType"}, 

        {key:"color", value:"textColor", type:"colorType"}, 
        {key:"background", value:"background", type:"colorType"},

        {key:"borderWidget", value:"borderWidget", type:"borderType"},
        {key:"borderRadius", value:"borderCorners", type:"borderType"}, 

        {key:"padding", value:"paddingWeb", type:"spacingType"},

        {key:"textColorClick", value:"textColorClick"},  
        {key:"backgroundClick", value:"backgroundClick"}, 

        {key:"textColorHover", value:"textColorHover"},  
        {key:"backgroundHover", value:"backgroundHover"}, 
    ],
    "footerNavigation":[ 
        {key:"fontFamily", value:"fontFamily", type:"fontType"}, 
        {key:"fontSize", value:"textSizeWeb", type:"fontType"}, 

        {key:"color", value:"textColor", type:"colorType"}, 
        {key:"background", value:"background", type:"colorType"},

        {key:"borderWidget", value:"borderWidget", type:"borderType"},
        {key:"borderRadius", value:"borderCorners", type:"borderType"}, 

        {key:"padding", value:"paddingWeb", type:"spacingType"},

        {key:"textColorClick", value:"textColorClick"},  
        {key:"backgroundClick", value:"backgroundClick"}, 

        {key:"textColorHover", value:"textColorHover"},  
        {key:"backgroundHover", value:"backgroundHover"}, 
    ],
    "logo":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},  
        {key:"padding", value:"paddingWeb"}
    ],
    "headerIcons":[
        {key:"color", value:"iconColor"}, 
        {key:"activeColor", value:"activeColor"}, 
        {key:"background", value:"iconBackground"},
        {key:"fontSize", value:"iconSizeWeb"},
        {key:"iconTextColor", value:"iconTextColor"}, 
        {key:"iconTextBgColor", value:"iconTextBgColor"}, 
        {key:"padding", value:"paddingWeb"}, 
    ],
    "video":[ 
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"} ,
        {key:"videoSrc", value:"videoSrc"} 
    ],
    "input":[
        {key:"fontSize", value:"textSizeWeb"},
        {key:"color", value:"textColor"}, 
        {key:"background", value:"background"},
        {key:"borderWidget", value:"borderWidget"},
        {key:"padding", value:"paddingWeb"} , 
        {key:"fontFamily", value:"fontFamily"},
        {key:"borderRadius", value:"borderCorners"},
    ],
    "list":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"}
    ],
    "pricingPlanPrice":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"}
    ],
    "skills":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"}
    ],
    "tags":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"fontSize", value:"textSizeWeb"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"}
    ]
}

export const elementsClass = {
    "text":["show","showWeb", "textAlignment"],
    "textHtml":["show","showWeb", "textAlignment"],
    "image":["show","showWeb"],
    "view":["show", "itemAlignment", "isFlipped", "fixedPosition", "isBlurImage", "hideHeader", "hideHeaderWeb"],
    "grid":["show", "spanWeb"],
    "gridItem":["show","showWeb", "isFlipped", "itemAlignment"],
    "socialLinks":["show","showWeb"], 
    "button":["show","showWeb"],
    "icon":["show","showWeb"],
    "gallery":["show","showWeb"],
    "contactLinks":["show","showWeb"],
    "maps":["show","showWeb"],
    "teamMembers":["show","showWeb"],
    "hours":["show","showWeb"],
    "advanceSocialLinks":["show","showWeb"],
    "video":["show","showWeb"],
    "item1":["show","showWeb"],
    "copyRight":["show","showWeb"],
    "input":["show","showWeb"],
    "list" : ["show","showWeb","textAlignment"],
    "pricingPlanPrice" : ["show","showWeb","textAlignment"],
    "skills" : ["show","showWeb","textAlignment"],
    "tags" : ["show","showWeb","textAlignment"]
}

export const svgIcon = {
    "edit":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path clipRule="evenodd" d="M20.5 6.5L7 20H2v-5L15.5 1.5l5 5zm-7.823.651L4 15.828V18h2.172l8.677-8.677-2.172-2.172zm3.586.758L17.672 6.5 15.5 4.328l-1.409 1.41 2.172 2.17z" fillRule="evenodd"></path></svg>,
    "delete":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path clipRule="evenodd" d="M8 2h6v2h5v2h-1v11a3 3 0 01-3 3H7a3 3 0 01-3-3V6H3V4h5V2zM6 6v11a1 1 0 001 1h8a1 1 0 001-1V6H6zm4 2v8H8V8h2zm4 0v8h-2V8h2z" fillRule="evenodd"></path></svg>,
    "copy":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path clipRule="evenodd" d="M2 16V2h14v4h4v14H6v-4H2zM4 4h10v10H4V4zm4 12v2h10V8h-2v8H8z" fillRule="evenodd"></path></svg>,
    "up":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path d="M4 12.75V10l7-7 7 7v2.75l-6-6V19h-2V6.75l-6 6z"></path></svg>,
    "down":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path d="M18 9.25V12l-7 7-7-7V9.25l6 6V3h2v12.25l6-6z"></path></svg>,
    "strike":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path d="M10 18h2v-6h-2v6zM3 11v-1h7V6H5V4h12v2h-5v4h7v1H3z"></path></svg>,
    "move":<svg fill="currentColor" height="50" viewBox="0 -960 960 960" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path xmlns="http://www.w3.org/2000/svg" d="M480-80 310-250l57-57 73 73v-206H235l73 72-58 58L80-480l169-169 57 57-72 72h206v-206l-73 73-57-57 170-170 170 170-57 57-73-73v206h205l-73-72 58-58 170 170-170 170-57-57 73-73H520v205l72-73 58 58L480-80Z"/></svg>,
    "bold":<svg fill="currentColor"  xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 22 22" width="50" className="svgicon"><path clipRule="evenodd" d="M5 4h6.5a4 4 0 013.42 6.076A4.5 4.5 0 0112 18H5V4zm3 3h3.5a1 1 0 110 2H8V7zm0 5v3h4a1.5 1.5 0 000-3H8z" fillRule="evenodd"></path></svg>,
    "italic":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 22 22" width="50" className="svgicon"><path d="M13.429 6L10.57 16H13v2H6v-2h2.571L11.43 6H9V4h7v2h-2.571z" id="yui_3_17_2_1_1703571306743_7099"></path></svg>,
    "underline":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path d="M200-120v-80h560v80H200Zm280-160q-101 0-157-63t-56-167v-330h103v336q0 56 28 91t82 35q54 0 82-35t28-91v-336h103v330q0 104-56 167t-157 63Z"/></svg>,
    "link":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z"/></svg>,
    "unlink":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path d="m770-302-60-62q40-11 65-42.5t25-73.5q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 57-29.5 105T770-302ZM634-440l-80-80h86v80h-6ZM792-56 56-792l56-56 736 736-56 56ZM440-280H280q-83 0-141.5-58.5T80-480q0-69 42-123t108-71l74 74h-24q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h65l79 80H320Z"/></svg>,
    "ai":<svg fill="currentColor" height="50" viewBox="0 0 22 22" width="50" xmlns="http://www.w3.org/2000/svg" className="svgicon"><path d="M12 0h-1L5 14h5v8h1l6-14h-5V0z"></path></svg>,
    "redo":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path d="M396-200q-97 0-166.5-63T160-420q0-94 69.5-157T396-640h252L544-744l56-56 200 200-200 200-56-56 104-104H396q-63 0-109.5 40T240-420q0 60 46.5 100T396-280h284v80H396Z"/></svg>,
    "undo":<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 -960 960 960" width="50" className="svgicon"><path xmlns="http://www.w3.org/2000/svg" d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z"/></svg>,
     
}
 
 
// A picked icon is either a font-icon class name ("ic_ai_icon_cart") or, since
// the icon picker gained a Custom Upload tab, the URL of an uploaded image —
// typically an SVG. A URL cannot go in className, so every renderer that paints
// a picked icon has to tell the two apart. Lives here rather than in
// components/helpers.js because the published page renders these too, and
// src/preview must not import the editor bundle.
export const isUploadedIcon = function(value) {
  return typeof value === "string" && value.indexOf("http") === 0;
};

// A menu item's stored value is rendered straight into an href by getLinkURL,
// so any scheme that can execute is a stored-injection vector — javascript: is
// the classic one, data: and vbscript: are the same idea. Checked on the way IN
// (ManageMenu's custom-URL tab) and again on the way OUT (getLinkURL), so a
// value saved before this guard existed is neutralised without a migration.
//
// Browsers ignore control characters and whitespace inside a scheme before
// acting on it — "java\nscript:alert(1)" still runs — so strip those first,
// the same normalisation the HTML editor's attribute sanitizer does.
//
// One javascript: form is first-party and must keep working: the deeplink the
// builder writes itself (components/helpers.js:5294), parses back out
// (components/helpers.js:1070, 1314, 1756), and hands to buttons as well as
// menu items — preview/helpers.js:282 drops target="_blank" for exactly this
// shape. Matched whole, not by prefix; a prefix test would wave through
//   javascript:opendeeplinkpage('');alert(1)//
// which opens with the allowed call and then runs whatever follows. The
// argument may hold the scheme's own "://" and "$$" but no quote, backslash,
// semicolon, parenthesis or angle bracket, so it cannot close the call early.
const DEEPLINK_HREF = /^javascript:opendeeplinkpage\('[^'"\\;()<>]*'\);?$/;

export const isUnsafeHref = function(value) {
  const v = String(value || "").replace(/[\u0000-\u0020]/g, "").toLowerCase();
  if (DEEPLINK_HREF.test(v)) return false;
  return /^(?:javascript|data|vbscript):/.test(v);
};
